var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.329l74.045-42.772 76.805 44.611-74.045 42.771z",
    fill: "#0E0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.329l74.045-42.772 76.805 44.611-74.045 42.771z",
    fill: "#0E0C0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "microsoft_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 151,
    height: 88
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.328l74.045-42.772 76.805 44.611-74.045 42.772z",
    fill: "#0E0C0C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#microsoft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.139 109.458L29.434 80.813 76.389 53.35l48.705 28.645-46.955 27.464z",
    fill: "#FF622B"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 -2.758 56.109)",
    fill: "url(#microsoft_svg__paint0_linear_3152_1028)",
    d: "M0 0h88.155v49.67H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 72.668 12.735)",
    fill: "url(#microsoft_svg__paint1_linear_3152_1028)",
    d: "M0 0h93.466v49.67H0z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.59 88.235L11.96 50.697l62.307-35.991 64.628 37.538-62.306 35.991z",
    fill: "#0E0C0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.59 73.53L11.96 35.99 74.268 0l64.628 37.539-62.306 35.99z",
    fill: "url(#microsoft_svg__paint2_linear_3152_1028)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.724 36.728l-17.69 10.214-17.691-10.214 17.69-10.213 17.69 10.213z",
    fill: "#F25022"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.253 25.452l-17.69 10.213-17.69-10.213 17.69-10.214 17.69 10.214z",
    fill: "#7FBA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.253 48.005l-17.69 10.213-17.69-10.213 17.69-10.214 17.69 10.214z",
    fill: "#00A4EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.784 36.728l-17.69 10.214-17.69-10.214 17.69-10.213 17.69 10.213z",
    fill: "#FFB900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 11.96 35.604)",
    fill: "url(#microsoft_svg__paint3_linear_3152_1028)",
    d: "M0 0h75.073v15.175H0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 76.977 73.063)",
    fill: "url(#microsoft_svg__paint4_linear_3152_1028)",
    d: "M0 0h71.498v15.274H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft_svg__paint0_linear_3152_1028",
    x1: 56.6,
    y1: -18.365,
    x2: 49.503,
    y2: 41.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft_svg__paint1_linear_3152_1028",
    x1: 60.009,
    y1: -18.365,
    x2: 15.047,
    y2: 39.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft_svg__paint2_linear_3152_1028",
    x1: 75.428,
    y1: 0,
    x2: 75.428,
    y2: 73.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft_svg__paint3_linear_3152_1028",
    x1: 37.537,
    y1: 0,
    x2: 37.537,
    y2: 48.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft_svg__paint4_linear_3152_1028",
    x1: 35.749,
    y1: 0,
    x2: 40.981,
    y2: 126.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4200"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgMicrosoft as ReactComponent };